import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import WorkloadViewSummaryConfigurationsItem from './workload-view-summary-configurations-item.vue';

type Props = {
  cache: boolean;
  cloud: boolean;
  predictive: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-configurations',
  props: {
    cache: { type: Boolean },
    cloud: { type: Boolean },
    predictive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-configurations flex gap-4 justify-stretch items-start" }, {
    default: _withCtx(() => [
      _createVNode(WorkloadViewSummaryConfigurationsItem, {
        "data-testid": "build-cache",
        title: _ctx.$t('workloads.details.summaryTab.configurations.buildCache'),
        exists: __props.cache
      }, null, 8, ["title", "exists"]),
      _createVNode(WorkloadViewSummaryConfigurationsItem, {
        "data-testid": "cloud-helpers",
        title: _ctx.$t('workloads.details.summaryTab.configurations.cloudHelpers'),
        exists: __props.cloud
      }, null, 8, ["title", "exists"]),
      _createVNode(WorkloadViewSummaryConfigurationsItem, {
        "data-testid": "predictive-execution",
        title: _ctx.$t('workloads.details.summaryTab.configurations.predictiveExecution'),
        exists: __props.predictive
      }, null, 8, ["title", "exists"])
    ]),
    _: 1
  }))
}
}

})